import { Handshake, Camera, Briefcase, Network, Bus, Award } from "lucide-react";
import Reveal from "@/components/Reveal";
import ThemeTag from "@/components/ThemeTag";

const VALUES = [
  {
    icon: Handshake,
    title: "Mentorship",
    body: "Direct guidance from experienced leaders, in the room and beyond the day.",
  },
  {
    icon: Camera,
    title: "Professional Headshots",
    body: "A polished portrait for LinkedIn and every career platform that matters.",
  },
  {
    icon: Briefcase,
    title: "Executive Materials",
    body: "Premium workbooks and session materials you will keep using long after.",
  },
  {
    icon: Network,
    title: "Networking",
    body: "A curated room of ambitious peers, mentors and useful connections.",
  },
  {
    icon: Bus,
    title: "Transport Allowance",
    body: "Support towards your journey to and from Aurora Conference Centre.",
  },
  {
    icon: Award,
    title: "Certificates of Completion",
    body: "Formal recognition for delegates who complete the full programme.",
  },
];

export default function ValueProps() {
  return (
    <section className="value-section">
      <div className="wrap">
        <Reveal className="head">
          <div className="kicker">Delegate value</div>
          <h2 className="title">What you walk away with.</h2>
          <ThemeTag />
          <p className="intro">
            Every selected delegate receives a package built to keep working long
            after the day ends.
          </p>
        </Reveal>
        <div className="cards value-grid">
          {VALUES.map((v, i) => (
            <Reveal key={v.title} delay={i * 0.07} className="card value-card" data-testid="value-prop-card">
              <div className="ico value-ico">
                <v.icon size={19} strokeWidth={2} />
              </div>
              <h3>{v.title}</h3>
              <p>{v.body}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
